"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const RightsholderRoyaltiesContentHeader = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("p", null, "Select your desired distribution period from the drop-down menu to see a summary of information for that period."),
    react_1.default.createElement("p", null, "Notes on blanket licensing activities and dates for historical unmatched royalties, as well as the distribution certification, are available in PDF form at the bottom of the screen. PLEASE NOTE: This information is not unique to your account.")));
exports.default = RightsholderRoyaltiesContentHeader;
